/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const UserIcon: React.FC<{ fill?: string }> = ({ fill = '#BCB1B0' }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24">
    <defs>
      <path
        id="user_a"
        d="M9 10c2.762 0 5-2.238 5-5s-2.238-5-5-5-5 2.238-5 5 2.238 5 5 5zm3.5 1.25h-.652A6.817 6.817 0 019 11.875a6.827 6.827 0 01-2.848-.625H5.5A5.252 5.252 0 00.25 16.5v1.625C.25 19.16 1.09 20 2.125 20h13.75c1.035 0 1.875-.84 1.875-1.875V16.5a5.252 5.252 0 00-5.25-5.25z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g transform="translate(3 2)">
        <mask id="user_b" fill="#fff">
          <use xlinkHref="#user_a" />
        </mask>
        <g fill={fill} mask="url(#user_b)">
          <path d="M-3-2h24v24H-3z" />
        </g>
      </g>
    </g>
  </svg>
)
